module.exports = __webpack_public_path__ + "img/hologram-map.99a550ca.svg";